import { FormulaScreenshot } from 'components/FormulaScreenshot';
import LehrEquationLight from "../../../../contents/images/docs/user-guides/experimentation/lehr-equation-light.png";
import LehrEquationDark from "../../../../contents/images/docs/user-guides/experimentation/lehr-equation-dark.png";
import SampleSizeDeterminationLight from "../../../../contents/images/docs/user-guides/experimentation/sample-size-determination-light.png";
import SampleSizeDeterminationDark from "../../../../contents/images/docs/user-guides/experimentation/sample-size-determination-dark.png";
import TrendExperimentCalculationLight from "../../../../contents/images/docs/user-guides/experimentation/trend-experiment-calculation-light.png";
import TrendExperimentCalculationDark from "../../../../contents/images/docs/user-guides/experimentation/trend-experiment-calculation-dark.png";
import FunnelExperimentCalculationLight from "../../../../contents/images/docs/user-guides/experimentation/funnel-experiment-calculation-light.png";
import FunnelExperimentCalculationDark from "../../../../contents/images/docs/user-guides/experimentation/funnel-experiment-calculation-dark.png";
import FunnelSignificanceLight from "../../../../contents/images/docs/user-guides/experimentation/funnel-significance-light.png";
import FunnelSignificanceDark from "../../../../contents/images/docs/user-guides/experimentation/funnel-significance-dark.png";
import * as React from 'react';
export default {
  FormulaScreenshot,
  LehrEquationLight,
  LehrEquationDark,
  SampleSizeDeterminationLight,
  SampleSizeDeterminationDark,
  TrendExperimentCalculationLight,
  TrendExperimentCalculationDark,
  FunnelExperimentCalculationLight,
  FunnelExperimentCalculationDark,
  FunnelSignificanceLight,
  FunnelSignificanceDark,
  React
};